import { render } from "./CampaignEvent.vue?vue&type=template&id=2c2f42cd"
import script from "./CampaignEvent.vue?vue&type=script&lang=js"
export * from "./CampaignEvent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__